import { Buffer } from 'buffer/index.js';

/* eslint-disable max-len */
/**
 * This class is used to prepare a message for signing by the user's wallet.
 * The message must be prefixed with a tag to indicate the domain of the message.
 * So that it can be verified by FCL library AppUtils.verifyUserSignature
 */
class PrepareMessage {
    static userMessage(message) {
        const instance = new PrepareMessage(message);
        return instance.prepare(PrepareMessage.USER_TAG);
    }
    static transactionMessage(message) {
        const instance = new PrepareMessage(message);
        return instance.prepare(PrepareMessage.TRANSACTION_TAG);
    }
    constructor(messageToSign) {
        this.messageToSign = messageToSign;
        if (typeof window !== 'undefined' && window.Buffer === undefined) {
            Object.assign(window, { Buffer });
        }
    }
    /**
     * See https://github.com/onflow/fcl-js/blob/b9c078c/packages/fcl-core/src/wallet-provider-spec/user-signature.md#userdomaintag
     * @returns Buffer
     */
    prependTag(tag) {
        const tagBuffer = Buffer.from(tag);
        const targetLength = Math.max(32, tag.length);
        const target = Buffer.alloc(targetLength, 0);
        tagBuffer.copy(target);
        return target;
    }
    prepare(tag) {
        const userDomainTag = this.prependTag(tag);
        const message = Buffer.from(this.messageToSign);
        const final = Buffer.concat([userDomainTag, message]);
        return final.toString('hex');
    }
}
PrepareMessage.TRANSACTION_TAG = 'FLOW-V0.0-transaction';
PrepareMessage.USER_TAG = 'FLOW-V0.0-user';

export { PrepareMessage };
